import { CalculateTourEss } from '@/domain/impact-calculate-tour/entities/calculate-tour-ess.entity';
import {
  EssSection,
  EssTopic,
} from '@/domain/impact-ess/entities/question.entity';
import { ProjectScoresDetailsData } from '@/ui/pages/app/components/project-page/ProjectScoresDetails/ProjectScoresDetails.types';
import {
  formatUnit,
  getEssSectionName,
  getEssTopicName,
} from '@/ui/utils/ess-env-names-and-format';

export function prepareProjectTourScoreDetailsDataEss(
  calculateEss: CalculateTourEss,
): ProjectScoresDetailsData[] {
  return [
    {
      title: getEssTopicName(EssTopic.PARITY_EQUALITY),
      value: calculateEss.general.topics.PARITY_EQUALITY.score,
      maxValue: calculateEss.general.topics.PARITY_EQUALITY.maxScore,
      refValue: NaN,
      viewMode: 'semi-circle',
      detailsValues: [
        {
          name: getEssSectionName(EssSection.ARTISTIC_TEAM),
          value:
            calculateEss.general.topics.PARITY_EQUALITY.sections.ARTISTIC_TEAM
              .score,
          unit: formatUnit(
            calculateEss.general.topics.PARITY_EQUALITY.sections.ARTISTIC_TEAM
              .maxScore,
          ),
          maxScore:
            calculateEss.general.topics.PARITY_EQUALITY.sections.ARTISTIC_TEAM
              .maxScore,
          topic: 'PARITY_EQUALITY',
          type: 'ess',
          section: 'ARTISTIC_TEAM',
        },
        {
          name: getEssSectionName(EssSection.PERMANENT_PRODUCTION_TEAM),
          value:
            calculateEss.general.topics.PARITY_EQUALITY.sections
              .PERMANENT_PRODUCTION_TEAM.score,
          unit: formatUnit(
            calculateEss.general.topics.PARITY_EQUALITY.sections
              .PERMANENT_PRODUCTION_TEAM.maxScore,
          ),
          maxScore:
            calculateEss.general.topics.PARITY_EQUALITY.sections
              .PERMANENT_PRODUCTION_TEAM.maxScore,
          topic: 'PARITY_EQUALITY',
          type: 'ess',
          section: 'PERMANENT_PRODUCTION_TEAM',
        },
        {
          name: getEssSectionName(EssSection.OCCASIONAL_OPERATIONAL_TEAM),
          value:
            calculateEss.general.topics.PARITY_EQUALITY.sections
              .OCCASIONAL_OPERATIONAL_TEAM.score,
          unit: formatUnit(
            calculateEss.general.topics.PARITY_EQUALITY.sections
              .OCCASIONAL_OPERATIONAL_TEAM.maxScore,
          ),
          maxScore:
            calculateEss.general.topics.PARITY_EQUALITY.sections
              .OCCASIONAL_OPERATIONAL_TEAM.maxScore,
          topic: 'PARITY_EQUALITY',
          type: 'ess',
          section: 'OCCASIONAL_OPERATIONAL_TEAM',
        },
        {
          name: getEssSectionName(EssSection.TRANSPARENCY_MANAGEMENT),
          value:
            calculateEss.general.topics.PARITY_EQUALITY.sections
              .TRANSPARENCY_MANAGEMENT.score,
          unit: formatUnit(
            calculateEss.general.topics.PARITY_EQUALITY.sections
              .TRANSPARENCY_MANAGEMENT.maxScore,
          ),
          maxScore:
            calculateEss.general.topics.PARITY_EQUALITY.sections
              .TRANSPARENCY_MANAGEMENT.maxScore,
          topic: 'PARITY_EQUALITY',
          type: 'ess',
          section: 'TRANSPARENCY_MANAGEMENT',
        },
      ],
    },
    {
      title: getEssTopicName(EssTopic.ACCESSIBILITY_SOCIAL_DIALOGUE),
      value: calculateEss.general.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.score,
      maxValue:
        calculateEss.general.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.maxScore,
      refValue: NaN,
      viewMode: 'semi-circle',
      detailsValues: [
        {
          name: getEssSectionName(EssSection.ACCESSIBILITY),
          value:
            calculateEss.general.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .ACCESSIBILITY.score,
          unit: formatUnit(
            calculateEss.general.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .ACCESSIBILITY.maxScore,
          ),
          maxScore:
            calculateEss.general.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .ACCESSIBILITY.maxScore,
          topic: 'ACCESSIBILITY_SOCIAL_DIALOGUE',
          type: 'ess',
          section: 'ACCESSIBILITY',
        },
        {
          name: getEssSectionName(EssSection.RISK_PREVENTION),
          value:
            calculateEss.general.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .RISK_PREVENTION.score,
          unit: formatUnit(
            calculateEss.general.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .RISK_PREVENTION.maxScore,
          ),
          maxScore:
            calculateEss.general.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .RISK_PREVENTION.maxScore,
          topic: 'ACCESSIBILITY_SOCIAL_DIALOGUE',
          type: 'ess',
          section: 'RISK_PREVENTION',
        },
        {
          name: getEssSectionName(EssSection.TEAM_MANAGEMENT),
          value:
            calculateEss.general.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .TEAM_MANAGEMENT.score,
          unit: formatUnit(
            calculateEss.general.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .TEAM_MANAGEMENT.maxScore,
          ),
          maxScore:
            calculateEss.general.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .TEAM_MANAGEMENT.maxScore,
          topic: 'ACCESSIBILITY_SOCIAL_DIALOGUE',
          type: 'ess',
          section: 'TEAM_MANAGEMENT',
        },
      ],
    },
    {
      title: getEssTopicName(EssTopic.LOCAL_IMPACT_RSE_ENGAGEMENT),
      value: calculateEss.general.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.score,
      maxValue:
        calculateEss.general.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.maxScore,
      refValue: NaN,
      viewMode: 'semi-circle',
      detailsValues: [
        {
          name: getEssSectionName(EssSection.ECONOMIC_SOCIAL_IMPACT),
          value:
            calculateEss.general.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
              .ECONOMIC_SOCIAL_IMPACT.score,
          unit: formatUnit(
            calculateEss.general.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
              .ECONOMIC_SOCIAL_IMPACT.maxScore,
          ),
          maxScore:
            calculateEss.general.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
              .ECONOMIC_SOCIAL_IMPACT.maxScore,
          topic: 'LOCAL_IMPACT_RSE_ENGAGEMENT',
          type: 'ess',
          section: 'ECONOMIC_SOCIAL_IMPACT',
        },
      ],
    },
  ];
}
